import { config } from 'config/constants';
import { IAppReducer } from 'models';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export const UserProductEdit = () => {
  const { userProductId, subId, subVersion } = useParams();
  const { authReducer: user } = useSelector((state: IAppReducer) => state);

  const authId = user.uid;
  const jwt = user.accessToken;
  const agentAuthId = user.agentAuthData ? user.agentAuthData.uid : '';

  const iframeUrl = `${config.soda.sodaUrl}/edit?authId=${encodeURIComponent(
    authId
  )}&token=${encodeURIComponent(
    jwt
  )}&userProductId=${userProductId}&agentAuthId=${agentAuthId}&subId=${subId}&subVersion=${subVersion}`;

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <iframe
        src={iframeUrl}
        width="100%"
        height="100%"
        title="Editar usuario producto"
        style={{ border: 'none' }}
      />
    </div>
  );
};
